// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MXmv1Vt1ToSTl-Nv0-5eP","avatarWrapper":"_5ncANA9u2d4UNN-zdTIja","avatar":"_16FkUDzUHjMGoq8LwvYUA","name":"_1eom3yhyYT3ufJNYu8tXIz","textTop":"UQ-ohLdj7i8sPtaJvFsCO"};